// shared/api/requests/ratings/due/request.ts
import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type DueRatingItem = {
  workItemId: number;
  workItemType: string;
  status: string;
  jobRole: string;
  startDate: string; // ISO date string
  endDate: string; // ISO date string
  createdAt: string;
  updatedAt: string;
  isArchived: boolean;
  ticketCreditation: boolean;
  expiration: string;
  artistProfileId: number;
  clubProfileId: number;
  newEndDate: string | null;
  approvedByClub: string;
  approvedByArtist: string;
  artistName: string;
  artistPhoto: string;
  clubName: string;
  clubPhoto: string;
  arrivalConfirmed: boolean;
  artistRequestedEndDate: boolean;
  migrated: boolean;
  rated: boolean;
};

export type RatingsDueRequest = {
  artistProfileId: string;
};

export type RatingsDueParams = RequestConfig<RatingsDueRequest>;

export const getRatingsDue = async ({ params, config }: RatingsDueParams) =>
  api.get<DueRatingItem[]>(
    `/api/ratings/due/${params.artistProfileId}`,
    config
  );
